import { render, staticRenderFns } from "./RemarkVisit.vue?vue&type=template&id=42e7da93&scoped=true&"
import script from "./RemarkVisit.vue?vue&type=script&lang=js&"
export * from "./RemarkVisit.vue?vue&type=script&lang=js&"
import style0 from "./RemarkVisit.vue?vue&type=style&index=0&id=42e7da93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e7da93",
  null
  
)

export default component.exports